import React, { useState } from "react";
import { Toaster } from "./components/ui/Sonner";
import { Screen } from "./components/common/GovShell";
import { PublicHome } from "./pages/PublicHome";
import { AuthPage, CitizenDashboard } from "./pages/AuthCitizen";
import { ApplicationFlow } from "./pages/ApplicationFlow";
import { CorrectionPage, PropertySearch, Receipt, Tracking } from "./pages/Tracking";
import { AdminDetail, ApplicationQueue } from "./pages/AdminWorkspaces";
import { Registry } from "./pages/RegistryReports";
import { AnalyticsDashboard, AnalyticsReportCenter } from "./pages/Analytics";
export function App() {
  const [screen, setScreen] = useState<Screen>("home");
  const route = () => {
    switch (screen) {
      case "home":
        return <PublicHome screen={screen} setScreen={setScreen} data-id="element-0" data-mp="2wifgbev2vaz8" />;
      case "auth":
        return <AuthPage screen={screen} setScreen={setScreen} data-id="element-1" data-mp="28te2td7e19n3" />;
      case "citizen":
        return <CitizenDashboard screen={screen} setScreen={setScreen} data-id="element-2" data-mp="23vuq4hqc94x9" />;
      case "application":
        return <ApplicationFlow screen={screen} setScreen={setScreen} data-id="element-3" data-mp="3ik7k0rkruvvx" />;
      case "receipt":
        return <Receipt screen={screen} setScreen={setScreen} data-id="element-4" data-mp="3mlj98vzqhf3l" />;
      case "tracking":
        return <Tracking screen={screen} setScreen={setScreen} data-id="element-5" data-mp="3mjg8pi0yg3km" />;
      case "correction":
        return <CorrectionPage screen={screen} setScreen={setScreen} data-id="element-6" data-mp="3rd1azm9kzjpm" />;
      case "propertySearch":
        return <PropertySearch screen={screen} setScreen={setScreen} data-id="element-7" data-mp="5gg5d4r3wxg" />;
      case "adminDistrict":
        return <AnalyticsDashboard screen={screen} setScreen={setScreen} variant="district" data-id="element-8" data-mp="2zmemk4sx3e5x" />;
      case "adminDivision":
        return <AnalyticsDashboard screen={screen} setScreen={setScreen} variant="division" data-id="element-9" data-mp="33mykhalbelt4" />;
      case "adminHead":
        return <AnalyticsDashboard screen={screen} setScreen={setScreen} variant="head" data-id="element-10" data-mp="38nupjrheke04" />;
      case "adminQueue":
        return <ApplicationQueue screen={screen} setScreen={setScreen} data-id="element-11" data-mp="3dii5h1ycc033" />;
      case "adminDetail":
        return <AdminDetail screen={screen} setScreen={setScreen} data-id="element-12" data-mp="nxn902b9pls4" />;
      case "registry":
        return <Registry screen={screen} setScreen={setScreen} data-id="element-13" data-mp="sssr0q1jugax" />;
      case "reports":
        return <AnalyticsReportCenter screen={screen} setScreen={setScreen} data-id="element-14" data-mp="356rv4texg92" />;
      default:
        return <PublicHome screen="home" setScreen={setScreen} data-id="element-15" data-mp="3ubrfsfo6881v" />;
    }
  };
  return <><a href="#main-content" className="skip-link" data-id="element-16" data-mp="d4e4tqw8j8vn">মূল কনটেন্টে যান</a><div id="main-content" data-id="element-17" data-mp="d2l9h7r2ob2y">{route()}</div><Toaster position="bottom-right" richColors data-id="element-18" data-mp="85ul7x54696g" /></>;
}